import React from 'react';

import { Dialog, DialogContentText, Button } from '@gogame/components';

const SateErrorsDialog = ({ errors, onUseDefaults }) => {
  console.log('errors', errors);
  return (
    <Dialog open={true} maxWidth={'sm'} fullWidth={true}>
      <Dialog.Title>Unable to display page </Dialog.Title>
      <Dialog.Content>
        <DialogContentText>
          The provided URL cannot load the desired data as it's missing some
          required parameters. Please make sure you have pasted the entire URL
          into the browser's address bar. Additionally, you should know that
          some email clients (e.g. Outlook) have a limit of 2083 characters for
          URLs.
        </DialogContentText>
      </Dialog.Content>
      <Dialog.Actions>
        <Button color={'primary'} autoFocus onClick={onUseDefaults}>
          Use Defaults
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default SateErrorsDialog;
